import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {switchMap} from 'rxjs/internal/operators';
import {catchError, map} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {currentClientActionTypes, LoadCurrentClientAction, LoadCurrentClientFailAction, LoadCurrentClientSuccessAction} from '../actions/current-client';
import {error} from '../actions/toasts';
import {Client} from '../models/client';

import {ClientsService} from '../services/clients.service';
import {BaseEffect} from './base.effect';
import {SendBackResult} from '..';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class CurrentClientEffect extends BaseEffect {

  load$ = createEffect(() => { return this.actions$.pipe(ofType(currentClientActionTypes.LOAD),
    debug('Load current client info action received.'),
    switchMap((action: LoadCurrentClientAction) => this.clientsService.getOne(action.payload)
      .pipe(
        map((payload: SendBackResult<Client>) => new LoadCurrentClientSuccessAction(payload.data)),
        catchError(res => this.catchResponseError(res)),
      )))
  });


  loadFail$ = createEffect(() => { return this.actions$.pipe(
                  ofType(currentClientActionTypes.LOAD_FAIL),
                  debug('A server error occurred while loading the current client details info.'),
                  map((action: LoadCurrentClientFailAction) =>
                    error(this.translation.translate('CURRENT_CLIENT_LOAD_ERROR') + '  ' + action.payload,
                      this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions, private translation: L10nTranslationService, private clientsService: ClientsService, router: Router) { super(router); }

  protected handleUnhandledError = (response) => new LoadCurrentClientFailAction(response['error'].message)

  protected handleGoneError = (response) => {
    return new LoadCurrentClientFailAction(response['error'].message);
  }
}
